module.exports = __webpack_public_path__ + "static/img/default.7ed8c60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/units/s_tree2_sprout/default.png
// module id = uy/A
// module chunks = 1